const initialState = {
  fetchingDataForModal: false,
  isRefreshingObligations: false,
  enabledFlagValues: [],
  yesNoOptionalValues: [],
  legalEntities: [],
  businessUnits: [],
  countryCodes: [],
  businessCodes: [],
  chartNames: [],
  connectionNames: [],
  currencyCodes: [],
  sourceOptions: [],
  usShareholderFlagValues: [],
  lineOfBusinessValues: [],
  homeOfficeCompanyCodeOptions: [],
  companyCodesOptionsToValidate: [],
};

export default initialState;
